import storageService from '@/services/storage.service'

const TOKEN_KEY = 'access_token'
const REFRESH_TOKEN_KEY = 'refresh_token'

const getToken = () => {
    return storageService.get(TOKEN_KEY)
}

const saveToken = (accessToken) => {
    storageService.set(TOKEN_KEY, accessToken)
}

const removeToken = () => {
    storageService.remove(TOKEN_KEY)
}

const getRefreshToken = () => {
    return storageService.get(REFRESH_TOKEN_KEY)
}

const saveRefreshToken = (refreshToken) => {
    storageService.set(REFRESH_TOKEN_KEY, refreshToken)
}

const removeRefreshToken = () => {
    storageService.remove(REFRESH_TOKEN_KEY)
}

export default {
    getToken,
    saveToken,
    removeToken,
    getRefreshToken,
    saveRefreshToken,
    removeRefreshToken,
}
